<template>
<span
    class="icon-info">
</span>
</template>

<script>
    export default {
        name: 'InfoIcon'
    }
</script>

<style scoped>
.icon-info {
    font-size: 2rem;
    margin: 0 15px 0 0;
}
</style>
